<template>
        <div class="homePage  new-content-holder" style="display: block;">
  
          <div class="home-banner">

          <VueSlickCarousel v-if="getPromotion.length > 0"  :infinite="true"  :swipe="true" :slidesPerRow="1" :slidesToShow="1" :centerPadding="'10%'" :autoplaySpeed="2000" :autoplay="true"  :centerMode="true"  :arrows="false"  :dots="false">
            <div class="imgSlideCon"  v-for="(item, i) in getPromotion" :key="i">
              <img class="imgSlide" :src="item.ImageUrl"  draggable="false" />
            </div>
          </VueSlickCarousel>

            </div>

            <!-- Announcement / Marquee Loading -->
            <!-- Announcement marquee -->
            <div class="ticker-panel">
              <div class="ticker-container">
                <div class="ticker-speaker">
                  <img
                    src="/static/img/landing/announcement.svg"
                    alt="announcement">
                    ❤️ฝากเร็วทันใจ ด้วยระบบออโต้ QRcode , Truewallet 
                      <br>
                      ⭐️แค่ชวนเพื่อนมาฝาก นอนรับยอดชิลๆ 30%
                      <br>
                      ❤️พร้อมทีมงานดูแลตลอดเวลา
                </div>
                <div class="ticker-content">
                  <div class="acmeticker-wrap" style="position: relative;">
                    <ul class="marquee-container" style="position: absolute; width: 3148.53px; left: -3069.9px;">
                      <li class="marquee-list" style="display: inline-block; margin-right: 10px;">
                        <div class="marQh">
                          <span class="ticker-txt-new">ใหม่</span>
                          <p style="color:#e222c9">
                            ❤️ฝากง่ายด้วยระบบออโต้,Truemoney
                            ❤️แนะนำเพื่อนรับ ได้ 25% จากยอดฝากของเพื่อน
                            ⭐Line ติดต่อได้ตลอด 24 ชั่วโมง
                            </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-holder">
       

              <div class="clearfix"></div>
            
              <!-- Our Providers -->
              <div class="section-providers homePage-items">
                <div class="providers-list-containers">
                  <div class="header-container provider-list-header">
                    <div class="vpTitle">
                      <img
                        src="/static/img/landing/our_providers.svg"
                        alt="our providers">
                      ผู้ให้บริการของเรา
                    </div>
                    <div class="list-control-container">
                      <div class="list-control-item previous disabled" data-type="provider">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i>
                      </div>
                      <div class="list-control-item next disabled" data-type="provider" disabled="disabled">
                        <i class="fa fa-chevron-right" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <div class="provider-list-body">
                    <div class="provider-list-category">
                      <!-- <div class="provider-list-category-item active" data-category="lottery">
                        <img
                          src="/static/img/landing/nav-lottery.svg"
                          alt="lottery">
                        <span>หวย</span>
                      </div>
                      <div class="provider-list-category-item " data-category="instantwin">
                        <img
                          src="/static/img/landing/nav-instantwin.svg"
                          alt="instantwin">
                        <span>ชนะทันที</span>
                      </div> -->    
                     
                     
                      <div @click="category = 'Casino'" 
                      :class="{'active':category == 'Casino'}" class="provider-list-category-item " data-category="live">
                        <img
                          src="/static/img/landing/nav-live.svg"
                          alt="live">
                        <span>คาสิโนสด</span>
                      </div>
                      <div :class="{'active':category == 'Slot'}" @click="category = 'Slot'" class="provider-list-category-item " data-category="slot">
                        <img
                          src="/static/img/landing/nav-slot.svg"
                          alt="slot">
                        <span>สล็อต</span>
                      </div>
                      <div :class="{'active':category == 'POKER'}" @click="category = 'POKER'" class="provider-list-category-item " data-category="card">
                        <img
                          src="/static/img/landing/nav-card.svg"
                          alt="card">
                        <span>การ์ดเกม</span>
                      </div>
                      <div :class="{'active':category == 'TRADING'}" @click="category = 'TRADING'" class="provider-list-category-item " data-category="esport">
                        <img
                          src="/static/img/landing/nav-esport.svg"
                          alt="esport">
                        <span>เทรด</span>
                      </div>
                      <!-- <div class="provider-list-category-item " data-category="fish">
                        <img
                          src="/static/img/landing/nav-fish.svg"
                          alt="fish">
                        <span>เกมส์ยิงปลา</span>
                      </div>
                      <div class="provider-list-category-item " data-category="sport">
                        <img
                          src="/static/img/landing/nav-sport.svg"
                          alt="sport">
                        <span>กีฬา</span>
                      </div> -->
                      <!-- <div class="provider-list-category-item " data-category="cockfight">
                        <img
                          src="/static/img/landing/nav-cockfight.svg"
                          alt="cockfight">
                        <span>ไก่ชน</span>
                      </div> -->
                    </div>

                    
                    <div v-if="category == 'Casino'" class="providerGameContainer">
                      <div class="list">
                        <a :key="`Casino-${index}`" v-for="(item, index) in getGameList.ImageCasino" class="provider-category-item"
                          href="/lottery/bgm" data-providername="BGM">
                          <img
                          :src="item.img">
                        </a>
                      </div>
                    </div>

                    <div v-if="category == 'Slot'" class="providerGameContainer">
                      <div class="list">
                        <a  :key="`ImageSlot-${index}`" v-for="(item, index) in getGameList.ImageSlot" class="provider-category-item"
                          href="/lottery/bgm" data-providername="BGM">
                          <img
                          :src="item.img">
                        </a>
                      </div>
                    </div>
                   
                    <div v-if="category == 'POKER'" class="providerGameContainer">
                      <div class="list">
                        <a :key="`ImagePOKER-${index}`" v-for="(item, index) in getGameList.ImagePOKER" class="provider-category-item"
                          href="/lottery/bgm" data-providername="BGM">
                          <img
                          :src="item.img">
                        </a>
                      </div>
                    </div>
                    <div v-if="category == 'TRADING'" class="providerGameContainer">
                      <div class="list">
                        <a :key="`ImageTRADING-${index}`" v-for="(item, index) in getGameList.ImageTRADING" class="provider-category-item"
                          href="/lottery/bgm" data-providername="BGM">
                          <img
                          :src="item.img">
                        </a>
                      </div>
                    </div>
                    

                     
                  </div>
                </div>
              </div>
              
              <!-- Exclusive Games -->
              <div class="vExclusiveGame game posRel homePage-items">
                <div class="header-container">
                  <div class="vpTitle">
                    <img
                      src="/static/img/landing/exclusive.svg"
                      alt="exclusive">
                    เกมพิเศษของเรา
                  </div>
                  <div class="list-control-container">
                    <div class="list-control-item previous disabled" data-type="exclusive">
                      <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    </div>
                    <div class="list-control-item next" data-type="exclusive">
                      <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                <div class="exclusiveGameContainer homePageGameContainer many-games">
                  <div class="list">
                    <div class="box" data-gameid="1728" data-name="Sweet Bonanza" data-pid="10"><img class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-PP-Sweet-Bonanza.jpg"
                        alt="Sweet Bonanza"
                        src="/static/img/landing/Online-Casino-Slot-Game-PP-Sweet-Bonanza.jpg">
                    </div>
                    <div class="box" data-gameid="5427" data-name="Treasures of Aztec" data-pid="83"><img
                        class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-PG-Treasures-of-Aztec.jpg"
                        alt="Treasures of Aztec"
                        src="/static/img/landing/Online-Casino-Slot-Game-PG-Treasures-of-Aztec.jpg">
                    </div>
                    <div class="box" data-gameid="5426" data-name="Mahjong Ways 2" data-pid="83">
                      <img class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-PG-Mahjong-Ways-2.jpg"
                        alt="Mahjong Ways 2"
                        src="/static/img/landing/Online-Casino-Slot-Game-PG-Mahjong-Ways-2.jpg">
                    </div>
                    <div class="box" data-gameid="5428" data-name="Lucky Neko" data-pid="83"><img class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-PG-Lucky-Neko.jpg"
                        alt="Lucky Neko"
                        src="/static/img/landing/Online-Casino-Slot-Game-PG-Lucky-Neko.jpg">
                    </div>
                     
                 
                  </div>
                </div>
              </div>

              <!-- Slot Games -->
              <div class="vSlotGame game posRel homePage-items">
                <div class="header-container">
                  <div class="vpTitle">
                    <img
                      src="/static/img/landing/popular_game.svg"
                      alt="popular">
                    เกมส์สล็อต
                  </div>
                  <div class="list-control-container">
                    <a href="/slot/all" class="more-button">
                      มากกว่า </a>
                    <div class="list-control-item previous disabled" data-type="slot">
                      <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    </div>
                    <div class="list-control-item next" data-type="slot">
                      <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                <div class="slotGameContainer homePageGameContainer many-games">
                  <div class="list">
                    <div class="box" data-gameid="1691" data-name="Roma" data-pid="6">
                      <img class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-Joker-Roma.jpg?v=8"
                        alt="Roma"
                        src="/static/img/landing/Online-Casino-Slot-Game-Joker-Roma.jpg">
                    </div>
                    <div class="box" data-gameid="9366" data-name="RomaX" data-pid="128">
                      <img class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-JILI-Roma-X.jpg?v=8"
                        alt="RomaX"
                        src="/static/img/landing/Online-Casino-Slot-Game-JILI-Roma-X.jpg">
                    </div>
                    <div class="box" data-gameid="1728" data-name="Sweet Bonanza" data-pid="10">
                      <img class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-PP-Sweet-Bonanza.jpg?v=8"
                        alt="Sweet Bonanza"
                        src="/static/img/landing/Online-Casino-Slot-Game-PP-Sweet-Bonanza(1).jpg">
                    </div>
                    <div class="box" data-gameid="5427" data-name="Treasures of Aztec" data-pid="83">
                      <img class="lazy image"
                        data-src="https://s3.ap-southeast-1.amazonaws.com/common-public/220x290/Online-Casino-Slot-Game-PG-Treasures-of-Aztec.jpg?v=8"
                        alt="Treasures of Aztec"
                        src="/static/img/landing/Online-Casino-Slot-Game-PG-Treasures-of-Aztec(1).jpg">
                    </div>
                     
                  </div>
                </div>
              </div>

              <!-- Mobile Leaderboard -->
              <div class="section-leaderboard m-dev">
                <div class="prize-section">
                  <div class="box">
                    <div class="img-box">
                      <img class="trophy"
                        src="/static/img/landing/new-trophy-mob.svg"
                        alt="trophy">
                    </div>

                    <div class="word">
                      <p>กองทุนรางวัลที่ใหญ่ที่สุด</p>
                      <p class="leaderboard-currency-text"><span class="leaderboard-currency">THB</span> 1,000,000</p>
                      <button class="btn-leaderboard"><a
                          href="/leaderboard">ข้อมูลเพิ่มเติม</a></button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
 
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getPrefix } from "@/services/modules/global.js";
import { reward } from "@/config/reward.js";
import carousel from "vue-owl-carousel";
import LoginForm from "@/components/form/LoginForm";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import RegisterForm from "@/components/form/RegisterForm";
// import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import carousel from "vue-owl-carousel";

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

// import { EffectCoverflow, Navigation, Pagination, Autoplay   } from "swiper";
// // import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
// import { Swiper, SwiperSlide} from 'swiper/vue';

import "swiper/swiper-bundle.css";
// SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow]);

// import "swiper/components/effect-coverflow/effect-coverflow.min.css";
// import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import api from "@/services/index.js";

export default {
  name: "Index",

  data() {
    return {
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
      showHeader: false,
      gameTab: 0,
      swiperOptions: {
        loop: true,
        slidesPerView: 1,
        navigation: false,
   
        autoplay: {
          delay: 1500,
        },
        centeredSlides: false,
        autoplayDisableOnInteraction: false,
        // direction: 'vertical',
        spaceBetween: 10,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      },
  
      availableBalance: "Loading...",
      availableCredit: "Loading...",
      isShowGame: true,
      chList: [],
      gameList: [],
      inGameList: false,
      ischName: "บริการของเรา",
      havelink: 0,
      gameListChunk: [],
      gameType: true,
      gameCH: this.$route.params.ch,
      chSlotList: [],
      gameCH: undefined,
      gameImg: "",
      gameType: "",
      gameCategory: "",
      productId: "",
      shareToken: this.$route.query.shareToken,
      category:
        this.$route.params.category == undefined
          ? "Casino"
          : this.$route.params.category,
      tab: 1,
    };
  },

  components: {
    Header,
    // Swiper,
    // SwiperSlide,
    VueSlickCarousel,
    Footer,
    LoginForm,
    RegisterForm,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "appTitle",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoCategory(category) {
      this.inGameList = false;
      this.category = category;
      this.$router.push(`/play/${category}`).catch(() => {});
    },

    gotoSub(route, item) {
      (this.gameImg = item.img
        .replace("game", "game_tranparent")
        .replace("game_betflik", "game_betflik_tranparent")),
        (this.gameType = item.gameType),
        (this.gameCategory = item.gameCategory),
        this.getGames(item.ch, item.gameType, item.category);
    },
    // async getChannels() {
    //   console.log("getChannels");

    //   await api
    //     .get("/user-profile-composite/v1/products")
    //     .then((v) => {
    //       if (v.success == true) {
    //         this.chList = v.data;
    //       } else {
    //         this.$swal.fire("แจ้งเตือน", v.message, "error");
    //       }
    //     })
    //     .catch((e) => {
    //       this.$swal.fire("แจ้งเตือน", e.message, "error");
    //     })
    //     .finally(() => {});
    // },
    async LoginGame(gameCode) {
      setTimeout(async () => {
        await api
          .get(`/user-profile-composite/v1/logIn/${this.productId}/${gameCode}`)
          .then((v) => {
            if (v.success == true) {
              if(v.data.url){
                setTimeout("location.href = '" + v.data.url + "';", 100);
              }else{
                this.$swal.fire("ไม่พบตัวเกม กรุณาลองใหม่อีกครั้ง", "", "error");
              }
            } else {
              this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            this.$swal.fire("แจ้งเตือน", e.message, "error");
          })
          .finally(() => {});
      }, 3000);
    },
    async getGames(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }
        console.log("NO LOBBY");
        console.log(filter);
        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => {});
      }
    },

    async getGamesPage(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }

        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              this.$router
                .replace(`/play/${this.category}/${filter}/${chId}`)
                .catch(() => {});
              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => {});
        // this.$router.push({ name: 'play', params: { category: this.category } });
        // this.$router.replace(`/play/${this.category}/${filter}/${chId}`).catch(() => { });
      }
    },
     
     

  },
  async mounted() {
  
    if (this.shareToken != undefined) {
      localStorage.setItem("shareToken", this.shareToken);
    } else {
      if (this.shareToken == undefined) {
        if (localStorage.getItem("shareToken")) {
          this.shareToken = localStorage.getItem("shareToken");
        }
      }
    }

    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }

    // await this.getChannels();

    if (this.$route.params.category != undefined) {
      this.category = this.$route.params.category;
      console.log(this.$route.params.category);

      if (
        this.$route.params.ch == undefined &&
        this.$route.params.gameType == undefined
      ) {
        console.log("chchch");
      } else {
        this.category = this.$route.params.category;
        this.inGameList = true;
        console.log("gameTypegameTypegameType");
        console.log(this.$route.params.gameType);
        console.log(this.$route.params.ch);
        this.getGames(
          this.$route.params.ch,
          this.$route.params.gameType,
          this.$route.params.category
        );
      }
    }
    $("#loginBtn").on("click", function() {
      $("#login").modal("show");
    });
    $("#registerBtn").on("click", function() {
      $("#register").modal("show");
    });
  },
  watch: {
    '$route.params.category': function(newParamValue, oldParamValue) {
        this.category = newParamValue
      // Do something when the query parameter changes
    },
    '$route.query.shareToken': function(newParamValue, oldParamValue) {
        this.shareToken = newParamValue
      // Do something when the query parameter changes
    }
  }, 
};
</script>
<style>
.modal-backdrop.show,
.overlaymodal {
  z-index: 0;
}
img {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}
.imgSlide{
  width:100%; object-fit: cover;
  border-radius: 10px;
}
.imgSlideCon{
  padding-left: 5px;padding-right: 5px;

}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/Index.vue